import { FuelTypography } from '@frete.com/fuel-react';
import styled from 'styled-components';

import { Form as DefaultForm } from '@/components';

export const Footer = styled.footer`
  display: flex;
  justify-content: end;
  margin-top: ${({ theme }) => theme.spacing.km8};
`;

export const Description = styled(FuelTypography).attrs({
  color: 'neutral-default',
  weight: 'medium',
  size: 'body-md',
})`
  max-width: 700px;
`;

export const Container = styled.div`
  margin-left: ${({ theme }) => theme.spacing.km12};
`;

export const Fields = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.spacing.km10};

  & > *:not(:last-child) {
    margin-right: ${({ theme }) => theme.spacing.km6};
  }
`;

export const Form = styled(DefaultForm)`
  max-width: 597px;
`;
